import React, { useMemo } from 'react';
import Select from 'react-select';
import { FiPlus } from 'react-icons/fi';
import styled from 'styled-components';
import palette from '../../lib/styles/palette';

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 24px;
  background: #fff;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: visible;
`;

const HeaderRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 18px 24px;
  background: #f8f9fb;
  border-radius: 12px;
`;

const Title = styled.div`
  font-size: 1.15rem;
  font-weight: 700;
  color: #2c3e50;
`;

const Controls = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

const SelectWrap = styled.div`
  width: 280px;
`;

const AddButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 18px;
  height: 42px;
  border-radius: 6px;
  border: none;
  background: ${palette.webCyan[5]};
  color: #fff;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.15s ease;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    font-size: 1.125rem;
  }
`;

const ClubSelectItem = ({
  clubList,
  setSelectClub,
  selectClub,
  onAddClick,
}) => {
  const selectedOption = useMemo(() => {
    if (!selectClub || !Array.isArray(clubList)) return null;
    return clubList.find((opt) => opt.value === selectClub) || null;
  }, [clubList, selectClub]);

  return (
    <Wrapper>
      <HeaderRow>
        <Title>클럽 선택</Title>
        <Controls>
          <SelectWrap>
            <Select
              options={clubList || []}
              value={selectedOption}
              onChange={(e) => setSelectClub(e?.value ?? 0)}
              isSearchable={false}
              styles={{
                container: (provided) => ({
                  ...provided,
                  width: '100%',
                  padding: 0,
                  border: 0,
                }),
                control: (provided) => ({
                  ...provided,
                  minHeight: 42,
                  border: '1px solid rgba(0, 0, 0, 0.12)',
                  borderRadius: 6,
                }),
              }}
              placeholder="클럽 선택"
              maxMenuHeight={350}
            />
          </SelectWrap>
          {onAddClick && (
            <AddButton type="button" onClick={onAddClick}>
              <FiPlus size={18} />
              클럽 추가
            </AddButton>
          )}
        </Controls>
      </HeaderRow>
    </Wrapper>
  );
};

export default React.memo(ClubSelectItem);
